import { Box, Typography, useTheme } from '@mui/material';
//import { AgGridReact } from 'ag-grid-react';
//import { ColDef } from 'ag-grid-community';
import { useMedia } from 'react-use';

import { useNavigate } from 'react-router-dom';
import { useProfile } from '../api/hooks';

export const Terms = () => {
  const navigate = useNavigate();
  const { profile } = useProfile();

  const isSuperAdmin =
    profile?.roles?.some((role) => role.type === 'SUPER_ADMIN') ?? false;
  const isAdmin =
    (profile?.roles?.some((role) => role.type === 'ADMIN') || isSuperAdmin) ??
    false;

  const hasAccess = isAdmin || isSuperAdmin;

  const isDarkTheme = useMedia('(prefers-color-scheme: dark)');
  const mobileFullWidth = 'calc(100vw - 32px)';

  const theme = useTheme();
  const isWide = useMedia('(min-width: 768px)');

  return (
    <>
      <Box
        sx={{
          maxWidth: '768px',
          margin: '0 auto',
          pt: '16px',
        }}
      >
        <Typography gutterBottom variant="h5" component="div">
          Terms of Service
        </Typography>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
        consectetur, nisl nec ultricies lacinia, nisl nisl aliquet nisl, nec
        tincidunt nisl nisl eget nisl. Donec euismod, nisl eget aliquam
        tincidunt, nisl nisl aliquet nisl, nec tincidunt nisl nisl eget nisl.
      </Box>
    </>
  );
};

export default Terms;
